module.exports = __webpack_public_path__ + "img/icon-twitter.dbc530c2.svg";